(function(){
var Q=window.MHTQA;if(!Q||Q.cols)return;
var RULES=[
['parfum,cologne,toilette',['deodorant','soin-du-corp']],
['deodorant,transpirant',['parfums','soin-du-corp']],
['serum',['visage','protection-solaire']],
['nettoyant,tonique,demaquillant,mousse',['serum','visage']],
['creme,hydratant,anti-rides,anti-age',['serum','protection-solaire']],
['solaire,spf,ecran',['visage','serum']],
['shampoing,shampooing',['apres-shampoing','masque-cheveux','huile-cheveux']],
['apres-shampoing,revitalisant,demelant,conditioner,rincage',['shampoing','masque-cheveux']],
['masque',['shampoing','apres-shampoing','huile-cheveux']],
['huile,coiffant,fixant',['shampoing','apres-shampoing']],
['coloration,teinture',['soin-des-cheveux','apres-shampoing']],
['fond de teint,foundation',['rouges-a-levres','mascara','fard-a-paupiere']],
['fard a joues,blush',['fond-de-teint','rouges-a-levres','mascara']],
['levres,gloss,lipstick,encre a levres',['fond-de-teint','mascara','fard-a-paupiere']],
['mascara,eyeliner,paupiere,sourcils,yeux',['fond-de-teint','rouges-a-levres']],
['vernis,ongles',['rouges-a-levres','fond-de-teint']],
['rasage,rasoir,barbe,shave',['deodorant','soin-du-corp']],
['douche,savon,lait,corps,vaseline',['deodorant','parfums']],
['bebe',['univers-bebe']]
];
function hay(p){var s=((p.type||p.product_type||'')+' '+((p.tags&&p.tags.join)?p.tags.join(' '):(p.tags||''))+' '+(p.title||'')).toLowerCase();return s.normalize('NFD').replace(/[\u0300-\u036f]/g,'');}
Q.cols=function(p){var h=hay(p);for(var i=0;i<RULES.length;i++){var kw=RULES[i][0].split(',');for(var k=0;k<kw.length;k++){if(h.indexOf(kw[k])>-1)return RULES[i][1];}}return null;};
Q.fav=function(p){var v=(p.variants||[]).filter(function(x){return x.available;})[0];return v&&v.id;};
Q.normRec=function(p){var vid=Q.fav(p);if(!vid)return null;return {id:p.id,title:p.title,vid:vid,price:Q.m(p.price),img:p.featured_image};};
Q.normCol=function(p){var v=(p.variants||[]).filter(function(x){return x.available;})[0];if(!v)return null;return {id:p.id,title:p.title,vid:v.id,price:Number(v.price).toLocaleString('fr-FR')+' FCFA',img:(p.images&&p.images[0]&&p.images[0].src)||''};};
})();